import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import {
  useContributions,
  useContributionSearchConditions,
} from 'src/api/contribution'
import { withLoginUser } from 'src/api/user'
import { ContributionsQueryParam } from 'src/models/Contribution'
import { isPaidForFilter } from 'src/models/User'
import { Loading } from '../../components/Loading'
import { ContributionsLayout } from './ContributionsLayout'

export const Contributions = withLoginUser(({ user }) => {
  const [page, setPage] = useState<number>(1)
  const { query } = useRouter()
  const { data, isValidating } = useContributions(
    query as unknown as ContributionsQueryParam,
    1,
  )
  const { data: contributionSearchConditionsData } =
    useContributionSearchConditions()
  useEffect(() => {
    query.page && setPage(Number(query.page))
  }, [query])

  if (isValidating || !data || !contributionSearchConditionsData)
    return <Loading isLoading={true} />

  const {
    contributions,
    contributionKeywords,
    totalCount,
    onePageDisplayItems,
    availableCount,
  } = data

  const paid = isPaidForFilter(user.plan.role)
  return (
    <ContributionsLayout
      user={user}
      contributions={contributions}
      contributionKeywords={contributionKeywords}
      queryParam={query as unknown as ContributionsQueryParam}
      currentPage={page}
      totalCount={totalCount}
      onePageDisplayItems={onePageDisplayItems}
      contributionSearchConditionsData={contributionSearchConditionsData}
      isPaidForFilter={paid}
      availableCount={availableCount}
    />
  )
})
